export const getMajorVersion = (version) => {
    // remove leading 'v' if it exists and split by '.'
    const versionParts = (version ?? '').replace(/^v/, '').split('.');
    // return the first part of the version
    const major = Number.parseInt(versionParts[0] ?? '');
    return Number.isNaN(major) ? 0 : major;
};
//# sourceMappingURL=getMajorVersion.js.map